import { INIT_CARTO, LOAD_MAP, LOAD_LAYER, LOAD_DATAVIEW, RESET_LAYERS, ADD_TO_MAP, APPLY_FILTER, ADD_POPUP, CLEAR_FILTERS } from './types';

/*
interface Layer = {
  name: 'Layer',
  viz: ``,
  sql: ``,
  loaded: false,
  filters: {}
  filterLabels: {}
}
*/

export const initCarto = () => dispatch => {
  dispatch({
    type: INIT_CARTO
  })
}

export const loadMap = () => dispatch => {
  dispatch({
    type: LOAD_MAP
  })
}

export const loadLayer = (layer) => (dispatch) => {
  if (!layer.filters) layer.filters = {}
  if (!layer.filterLabels) layer.filterLabels = {}
  dispatch({
    type: LOAD_LAYER,
    payload: layer
  })
}

export const loadDataview = (dataview) => (dispatch) => {
  dataview.filters = {}
  dataview.filterLabels = {}
  dispatch({
    type: LOAD_DATAVIEW,
    payload: dataview
  })
}

export const resetLayers = () => dispatch => {
  dispatch({
    type: RESET_LAYERS
  })
}

export const addToMap = (layerName) => (dispatch, getState) => {
  const layer = getState().carto.layers[layerName]
  layer.loaded = true
  dispatch({
    type: ADD_TO_MAP,
    payload: layer
  })
}

export const updateLayerFilter = (layerName, field, values, label) => (dispatch, getState) => {
  let layer = getState().carto.layers[layerName] ? getState().carto.layers[layerName] : getState().carto.dataviews[layerName]
  if (!layer.filters) layer.filters = {}
  values.length ? layer.filters[field] = values : delete layer.filters[field]
  layer.filterLabels[field] = label
  dispatch({
    type: APPLY_FILTER,
    payload: { layerName, filters: layer.filters, filterLabels: layer.filterLabels }
  })
}

export const addPopup = (layerName, eventName, popupContent) => (dispatch, getState) => {
  dispatch({
    type: ADD_POPUP,
    payload: { layerName, eventName, popupContent }
  })
}

export const clearFilters = (layerName) => (dispatch) => {
  dispatch({
    type: CLEAR_FILTERS,
    payload: { layerName }
  })
  return Promise.resolve();
}